export enum TxSpeed {
  slow = 'slow',
  normal = 'normal',
  fast = 'fast',
  instant = 'instant',
}
